import {
  Box,
  makeStyles,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { FilterButton } from "./filterButton";
import { TypeFilters } from "./typeFilters";
import { RangeFilters } from "./rangeFilters";
import { StatusFilters } from "./statusFilters";
import { RecencyFilters } from "./recencyFilters";
import { BedsAndBathsFilters } from "./bedsAndBathsFilters";
import { MoreFilters } from "./moreFilters";
import { useRef } from "react";
import { useStore } from "@roc/client-portal-shared/hooks";
import { ActiveFilters } from "./activeFilters";
import FilterPreset from "./filterPreset";
import { observer } from "mobx-react";
const useStyles = makeStyles((theme) => ({
  flexButton: {
    flex: "1.5",
  },
}));

export const ComparablesFilters = observer(() => {
  const { compToolStoreV2: compToolStore } = useStore();
  const { compToolFiltersStore } = compToolStore;
  const typeFiltersRef = useRef();
  const daysOnMarketFiltersRef = useRef();
  const distanceFiltersRef = useRef();
  const recencyFiltersRef = useRef();
  const bedsAndBathsFiltersRef = useRef();
  const statusFiltersRef = useRef();
  const moreFiltersRef = useRef();
  const isPresetActive = !!compToolFiltersStore.activePreset;

  const applyFilters = (filtersRef) => {
    const activeListingsChecked = compToolFiltersStore.form.fields.ACTIVE_LISTINGS.values.value?.length === 1;
    const soldListingsChecked = compToolFiltersStore.form.fields.IS_ACTIVE.values.value?.length === 0;
    if (!activeListingsChecked && !soldListingsChecked) {
      compToolFiltersStore.globalStore.notificationStore.showErrorNotification({
        message: 'At least one of the following filters must remain active: Active Listings or Sold Listings',
      });
      compToolFiltersStore.onFieldsChange('IS_ACTIVE', 'values', []);
    }

    filtersRef && filtersRef.current.close();
    compToolStore.applyFilters();
  }

  const applyPresetFilter = (preset) => {
    compToolFiltersStore.clearFilters();
    compToolStore.setDefaultFilters();
    compToolFiltersStore.onFieldsChange('PRESET', 'values', preset);
    compToolStore.applyFilters();
  }

  return (
    <Box display="flex" flexDirection="column" gridGap="8px">
      <Box display="flex" justifyContent="start" gridGap="8px" flexWrap="wrap">
        <FilterPreset onApply={(preset) => applyPresetFilter(preset)} />
        <FilterButton
          ref={typeFiltersRef}
          disabled={isPresetActive}
          buttonLabel="Type"
          endIcon={<ExpandMoreIcon />}
          popoverContent={<TypeFilters onApply={() => applyFilters(typeFiltersRef)} />}
        />
        <FilterButton
          ref={daysOnMarketFiltersRef}
          disabled={isPresetActive}
          buttonLabel="Days on Market"
          endIcon={<ExpandMoreIcon />}
          popoverContent={<RangeFilters label="Days On Market" fieldName="DOM" onApply={() => applyFilters(daysOnMarketFiltersRef)} />}
        />
        <FilterButton
          ref={distanceFiltersRef}
          disabled={isPresetActive}
          buttonLabel="Distance"
          endIcon={<ExpandMoreIcon />}
          popoverContent={<RangeFilters label="Distance from Subject Property (miles)" fieldName="GEO__DIST" onApply={() => applyFilters(distanceFiltersRef)} />}
        />
        <FilterButton
          ref={statusFiltersRef}
          disabled={isPresetActive}
          buttonLabel="Status"
          endIcon={<ExpandMoreIcon />}
          popoverContent={<StatusFilters onApply={() => applyFilters(statusFiltersRef)} />}
        />
        <FilterButton
          ref={recencyFiltersRef}
          disabled={isPresetActive}
          buttonLabel="Recency"
          endIcon={<ExpandMoreIcon />}
          popoverContent={<RecencyFilters onApply={() => applyFilters(recencyFiltersRef)} />}
        />
        <FilterButton
          ref={bedsAndBathsFiltersRef}
          disabled={isPresetActive}
          buttonLabel="Beds & Baths"
          endIcon={<ExpandMoreIcon />}
          popoverContent={<BedsAndBathsFilters onApply={() => applyFilters(bedsAndBathsFiltersRef)} />}
        />
        <FilterButton
          ref={moreFiltersRef}
          disabled={isPresetActive}
          buttonLabel="More"
          endIcon={<ExpandMoreIcon />}
          popoverContent={<MoreFilters onApply={() => applyFilters(moreFiltersRef)} />}
        />
      </Box>
      <ActiveFilters />
    </Box>
  );
});
